import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

import type { CloseDialogProps } from '@/features/app/dialogs/types';

const DialogLoadingState = ({ onClose }: CloseDialogProps) => {
    return (
        <div className="bg-white min-height-200">
            <Dialog.Title
                title={<FormattedMessage id="intl-msg:engineOil.table.loading" />}
                onCloseButtonClick={onClose}
            />
            <Dialog.Body className="padding-15 margin-left-15">
                <div className="row col-xs-6">
                    <Spinner />
                </div>
            </Dialog.Body>
        </div>
    );
};

export default DialogLoadingState;
